<template>
  <div class="vx-row mb-6">
    <div class="vx-col sm:w-1/5 w-full">
      <span>Voucher name</span>
    </div>
    <div class="vx-col sm:w-4/5 w-full">
      <vs-input placeholder="Voucher name" v-model="voucherName" />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  components: {},
  props: ["action", "automationId"],
  data() {
    return {
      voucherName: "",
    };
  },
  methods: {
    render() {
      return {
        voucherName: this.voucherName,
      };
    },
  },
  computed: {
    ...mapGetters({
      triggerTypes: "automations/triggerTypes",
    }),
  },
  async mounted() {
    if (this.action) {
      this.voucherName = this.action.voucherName;
    }
  },
};
</script>

<style lang="scss">
</style>